import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { InputRadioProps } from './input-radio.type';

export const InputRadio = forwardRef(
  (
    {
      id,
      name,
      disabled,
      label,
      secondaryLabel,
      strikeThrough,
      checked,
      containerClassName,
      value,
      onChange,
      ...props
    }: InputRadioProps,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <label
        className={classNames('flex items-center transition', containerClassName, {
          'cursor-pointer': !disabled,
          'border-extra-soft': !checked,
        })}>
        <div
          className={classNames('leading-none', {
            'text-subtitle-m': checked,
            'text-body-m': !checked,
            'text-primary': !disabled,
            'text-tertiary': disabled,
            'line-through': disabled && strikeThrough,
          })}>
          <input
            ref={ref}
            {...props}
            id={id}
            name={name}
            disabled={disabled}
            type='radio'
            className={classNames(
              'mr-3 h-6 w-6 border rounded-full bg-primary',
              'focus:checked:bg-fill-dark focus:checked:border-black focus:ring-black',
              'checked:fill-dark checked:dark:fill-primary checked:border-black',
              'checked:disabled:fill-dark-disabled checked:border-hard checked:disabled:text-tertiary'
            )}
            value={value}
            checked={checked}
            onChange={onChange}
          />
          {label}
        </div>
        {secondaryLabel && <span className='pl-2 text-tertiary text-body-s'>{secondaryLabel}</span>}
      </label>
    );
  }
);
